import styled from "styled-components";
import { InputWrapper } from "./InputBase";
import React, { forwardRef, useEffect } from "react";

const ListOuterWrapper = styled.div`
  width: ${({ $width }) => $width || "inherit"};
  height: ${({ $height }) => $height || "inherit"};
  overflow: hidden;
  position: relative;
`;

const ListInnerWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow: auto;
  scrollbar-width: none;
  flex-direction: ${({ $direction }) => $direction};
  gap: ${({ $gap }) => $gap};

  & > * {
    flex-shrink: 0;
  }
`;

export const ListWrapper = forwardRef(
  (
    {
      label,
      caption,
      required,
      width,
      height,
      itemWidth,
      itemHeight,
      direction = "row",
      gap,
      children,
    },
    ref,
  ) => {
    const firstChild = Array.isArray(children) ? children[0] : children;
    const resolvedItemWidth = itemWidth ?? firstChild?.props?.width;
    const resolvedItemHeight = itemHeight ?? firstChild?.props?.height;

    useEffect(() => {
      const el = ref.current;
      if (!el) return;

      const handleWheel = (e) => {
        const canScroll = el.scrollWidth > el.clientWidth;
        if (!canScroll || e.deltaY === 0) return;

        e.preventDefault();
        el.scrollLeft += e.deltaY;
      };

      el.addEventListener("wheel", handleWheel, { passive: false });
      return () => el.removeEventListener("wheel", handleWheel);
    }, [ref]);

    return (
      <InputWrapper label={label} caption={caption} rules={{ required }}>
        <ListOuterWrapper $width={width} $height={height}>
          <ListInnerWrapper
            ref={ref}
            $direction={direction}
            $gap={gap}
            style={{ scrollbarWidth: "auto" }}>
            {React.Children.map(children, (child) =>
              React.cloneElement(child, {
                width: resolvedItemWidth,
                height: resolvedItemHeight,
              }),
            )}
          </ListInnerWrapper>
        </ListOuterWrapper>
      </InputWrapper>
    );
  },
);
